import { ApolloError } from '@apollo/client'
import { openToast } from '@web/components/Toast/GlobalToastPortal'
import { Nullish } from '@web/types'
import { useEffect } from 'react'

export const useErrorToast = (error: Nullish<ApolloError>, showToast = true) => {
  useEffect(() => {
    if (error && showToast) {
      openToast({ title: '일부 정보를 불러오는데 실패했습니다.', text: '잠시 후 다시 시도해주세요', iconType: 'error' })
    }
  }, [error, showToast])
}
